export default {
    '-': "-",
    actions: "Дії",
    actions_with_selected: "Дії з вибраними",
    active: "Активний",
    add: "Додати",
    add_attachment: "Додати додаток",
    add_condition: "Додати умову",
    afternoon: "День",
    all: "Все",
    app_is_in_maintenance_mode: "У додатку ведуться технічні роботи. Ми обов'язково скоро повернемось",
    are_you_sure_you_want_to_delete: "Ви впевнені, що хочете видалити матеріал?",
    are_you_sure_you_want_to_logout: "Ви впевнені, що хочете вийти?",
    assistant_id: "Помічник",
    authorization: "Авторизація",
    authorize_in_system: "Авторизуйтеся в системі",
    azerbaijani: "Азербайджанська",
    balance: "Депозит",
    cancel: "Відміна",
    cancel_verb: "Скасувати",
    change: "Змінити",
    change_password: "Змінити пароль",
    comment: "Коментар",
    confirm_deletion: "Підтвердити видалення?",
    contacts: "Контакти",
    contains: "Містить",
    continue: "Продовжити",
    credit: "Кредит",
    currency: "Валюта",
    custom_role_rights_updated: "Права ролі оновлено",
    delete: "Видалити",
    dentistry: "Стоматологія",
    do_not_save: "Не зберігати",
    does_not_equal: "Не дорівнює",
    done: "Готово",
    down: "Униз",
    edit: "Редагувати",
    egisz_send_error: "Помилка відправлення в ЕГИСЗ",
    egisz_send_success: "Успішне відправлення в ЕГИСЗ",
    email: "Email",
    email_required_for_password_reset: "Щоб скинути пароль цього користувача, потрібно вказати його email",
    end: "Закінчення",
    english: "Англійська",
    enter_username_to_reset_password: "Введіть логін, щоб отримати посилання для скидання пароля",
    equals: "Дорівнює",
    error: "Помилка",
    error_message: "Щось пішло не так, операція не була завершена успішно",
    evening: "Вечір",
    excel: "Excel",
    exported_patients_to_excel: "Завантажив пацієнтів в excel",
    exported_report_to_excel: "Вивантажив звіт в excel",
    fact: "Факт",
    family_account_member_toggled: "Змінив активність учасника сімейного рахунку",
    family_account_updated: "Оновив склад сімейного рахунку",
    file: "Файл",
    file_does_not_exist: "Файл не знайдено",
    file_size_is_too_big: "Розмір файла дуже великий",
    filled: "Заповнене",
    filled_not_signed: "Заповнене / не підписане",
    filter: "Фільтр",
    finish: "Завершити",
    finishing_operation: "Завершення операції",
    forgot_password: "Забули пароль?",
    from_to: "Від {from} до {to}",
    general_cost: "Загальна вартість",
    general_medicine: "Загальна медицина",
    general_slogan: "Хмарне рішення для управління сучасною клінікою",
    hide: "Сховати",
    hide2: "Приховати",
    home: "Головна",
    image: "Зображення",
    import: "Iмпорт",
    in_interval: "В інтервалі",
    input_field: "Поле для введення тексту",
    integration: "Інтеграція",
    invalid_reset_link: "Це посилання для скидання пароля недійсне або термін його дії закінчився",
    kazakh: "Казахська",
    kyrgyz: "Киргизька",
    KZT: "KZT",
    language: "Мова",
    less: "Менше за",
    links: "Посилання",
    load_more: "Завантажити ще",
    logged: "Авторизований",
    logged_out: "Вийшов із системи",
    login: "Логін",
    login_disclaimer: "Продовжуючи авторизацію в DENTIST PLUS, ви підтверджуєте використання власного облікового запису та берете на себе відповідальність за дії, вчинені з використанням ваших облікових даних. Передача облікових даних третім особам заборонена.",
    login_failed: "Невдала спроба входу",
    login_locked_out: "Вхід заблоковано (багато спроб)",
    login_or_pass_incorrect: "Логін і / або пароль неправильні",
    logout: "Вийти",
    main: "Головна",
    message: "Повідомлення",
    module_unavailable: "Модуль недоступний",
    months: "Місяців",
    more: "Більш за",
    more_2: "більше",
    morning: "Ранок",
    must_change_password_notice: "Щоб продовжити, потрібно змінити пароль",
    name: "Ім'я",
    new_password: "Новий пароль",
    no: "Ні",
    no_data_available: "Даних поки що немає",
    nonactive: "Неактивний",
    not_enough_rights_for_this_operation: "Недостатньо прав для цієї операції",
    not_filled: "Не заповнено",
    nothing_found: "Нічего не знайдено",
    old_password: "Старий пароль",
    on_page: "На сторінці",
    page_not_found: "Сторінка не знайдена",
    password: "Пароль",
    password_changed: "Пароль змінений",
    password_confirm: "Підтвердження пароля",
    password_reset_link_sent: "Якщо обліковий запис із таким логіном існує, на його email надіслано посилання для скидання пароля",
    password_reset_failed: "Невдала спроба скидання пароля",
    password_reset_requested: "Запросив скидання пароля",
    password_reset_succeeded: "Успішно скинув пароль",
    passwords_do_not_match: "Паролі не співпадають",
    patient_search: "Пошук пацієнта",
    patient_tags_updated: "Оновив мітки пацієнта",
    payment_expires_at: "Оплата закінчується",
    phone: "Телефон",
    photo: "Фото",
    price: "Ціна",
    print_noun: "Друк",
    professional: "професійний",
    profile: "Профіль",
    program: "Програма",
    refresh: "Оновити",
    registration: "Реєстрація",
    requirements: "Вимоги",
    reset: "Скидання",
    reset_password: "Скидання пароля",
    reset_password_email_note: "Користувач отримає на пошту посилання для встановлення нового пароля",
    reset_success: "Листа для скидання відправлено на ваш E-mail",
    role: "Роль",
    russian: "Російська",
    save: "Зберегти",
    search: "Пошук",
    select: "Вибрати",
    send_reset_link: "Надіслати посилання",
    sent: "Відправлено",
    session_revoked: "Відкликав сесію",
    sessions_revoked: "Відкликав усі інші сесії",
    settings: "Налаштування",
    show: "Показати",
    show_full: "Показати повністю",
    signin: "Увійти",
    slogan: "Хмарне рішення для керування сучасною стоматологією",
    sorting: "Сортування",
    staff_rights_updated: "Права співробітника оновлено",
    staff_role_updated: "Роль співробітника оновлено",
    start: "Почати",
    start_noun: "Початок",
    status: "Статус",
    subscription_sum: "Сума за передплату",
    success_message: "Операція пройшла успішно",
    sum: "Сума",
    system: "Системний",
    table_search: "Пошук по таблиці",
    tech_specialist: "Технічний спеціаліст",
    text: "Текст",
    there_are_unsaved_changes: "Є незбережені зміни",
    this_module_is_not_in_tariff: "Цей модуль не входить в тариф Free, вам потрібно підключити Standard або Premium, і ви отримаєте доступ до великої кількості функціоналу програми Dentist Plus.",
    title: "Назва",
    to_top: "Нагору",
    today: "Сьогодні",
    total: "Усього",
    translation: "Переклад",
    unknown: "Невідомо",
    upload: "Завантажити",
    web: "Web",
    who_has_access: "Кому доступно",
    wrong_file_format: "Неправильний формат файлів",
    yes: "Так"
}
